import styled from 'styled-components';

export const KeyboardContainer = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 650px;

  div {
    width: auto;
    display: flex;
    flex-direction: row;
    gap: 5px;

    @media (max-width: 490px) {
      gap: 3px;
    }

    @media (min-width: 550px) {
     display: none;
    }
  }

  button{
    position: relative;
    font-weight: bold;
    font-size: 1.6rem;
    border: 2px solid;
    padding: 4px 20px;
    min-width: 50px;
    border-radius: 4px;
    margin-bottom: 4px;
    cursor: pointer;
    user-select: none;
    text-transform: uppercase;
    border: 2px solid ${({ theme }) => theme.text};
    color: ${({ theme }) => theme.text};
    background-color: ${({ theme }) => theme.background};
    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
    -o-animation-fill-mode: forwards;
    -ms-animation-fill-mode: forwards;
    animation-fill-mode: forwards;

    @media (max-width: 580px) {
      padding: 4px 15px;
    }

    @media (max-width: 555px) {
      min-width: 45px;
    }

    @media (max-width: 506px) {
      min-width: 40px;
    }

    @media (max-width: 490px) {
      padding: 4px 13px;
      border: 1px solid ${({ theme }) => theme.text};
      font-weight: 600;
    }

    @media (max-width: 442px) {
      min-width: 35px;
    }

    @media (max-width: 425px) {
      padding: 4px 11px;
    }

    @media (max-width: 400px) {
      min-width: 20px;
    }

    @media (max-width: 382px) {
      font-size: 1.3rem;
    }

    @media (max-width: 360px) {
      font-size: 1.2rem;
    }

    @media (max-width: 350px) {
      font-size: 1.1rem;
    }

    @media (max-width: 340px) {
      font-size: 1rem;
      min-width: 0px;
    }

    @media (max-width: 335px) {
      font-size: 0.8rem;
      padding: 3px 10px;
    }

    @media (max-width: 300px) {
      padding: 2px 8px;
    }

    @media (min-width: 250px) and (max-height: 645px) {
      font-size: 1.4rem;
    }

    @media (min-width: 250px) and (max-height: 560px) {
      font-size: 1.2rem;
      padding: 0 13px;
    }

    @media (min-width: 250px) and (max-height: 505px) {
      font-size: 1rem;
      padding: 0 12px;
      border: 1px solid ${({ theme }) => theme.backgroundWordle};
    }

    @media (min-width: 250px) and (max-height: 460px) {
      font-size: 0.9rem;
    }

    @media (min-width: 250px) and (max-height: 416px) {
      font-size: 0.7rem;
    }

    @media (min-width: 250px) and (max-height: 645px) {
      padding: 0 6px;
    }
  }

  button.key-correct{
    animation-duration: 0.5s;
    animation-delay: 2.7s;
    animation-name: RightButton;
  
    @keyframes RightButton {
      100% {background-color: ${({ theme }) => theme.green}; color: ${({ theme }) => theme.white}}
    }
  }

  button.key-present{
    animation-duration: 0.5s;
    animation-delay: 2.7s;
    animation-name: PresentButton;
  
    @keyframes PresentButton {
      100% {background-color: ${({ theme }) => theme.yellow}; color: ${({ theme }) => theme.white}}
    }
  }

  button.key-absent{
    animation-duration: 0.5s;
    animation-delay: 2.7s;
    animation-name: AbsentButton;
  
    @keyframes AbsentButton {
      100% {background-color: ${({ theme }) => theme.gray}; color: ${({ theme }) => theme.white}}
    }
  }
`